<template>
  <div class="cdsjs-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="设计师姓名"
                    width="120"
                    align="center"
                    prop="dName"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    label="待拆单总数"
                    width="100"
                    align="center"
                    prop="splitNum">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color: #409EFF">{{ scope.row.splitNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="待拆正单数"
                    width="100"
                    align="center"
                    prop="splitZDNum">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color: #409EFF">{{ scope.row.splitZDNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="待拆补单数"
                    width="100"
                    align="center"
                    prop="splitBDNum">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color: #409EFF">{{ scope.row.splitBDNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="待拆售后单数"
                    width="100"
                    align="center"
                    prop="splitSHNum">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color: #409EFF">{{ scope.row.splitSHNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="待拆色板单数"
                    width="100"
                    align="center"
                    prop="splitSBNum">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color: #409EFF">{{ scope.row.splitSBNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="手机号"
                    prop="dUsername"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="组织名称"
                    prop="group_abbname"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="部门名称"
                    prop="dept_name"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="职位名称"
                    align="center"
                    prop="position_name"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    min-width="120"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button :disabled="scope.row.splitNum === 0" size="mini" icon="el-icon-search" @click="getDetail(scope.row.dUserid)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="拆单详情"
      :visible.sync="visible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row v-loading="dialogLoading">
        <el-col :span="24" v-loading="loading">
          <el-table
            :data="dialogData"
            style="width: 100%">
            <el-table-column
              label="订单号"
              min-width="100"
              prop="ordernum">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="goDetail(scope.row.orderid)">{{ scope.row.ordernum }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="订单类型"
              min-width="100"
              align="center"
              :filters="[{text: '正单', value: 0}, {text: '客改单', value: 1}, {text: '增补单', value: 2}, {text: '色板单', value: 3}, {text: '售后单', value: 4}]"
              :filter-method="filterType"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.type===0">正单</span>
                <span v-if="scope.row.type===1">客改单</span>
                <span v-if="scope.row.type===2">增补单</span>
                <span v-if="scope.row.type===3">色板单</span>
                <span v-if="scope.row.type===4">售后单</span>
              </template>
            </el-table-column>
            <el-table-column
              label="经销商"
              min-width="100"
              prop="all_name">
              <template slot-scope="scope">
                <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                  {{ scope.row.all_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="详细地址"
              min-width="160"
              prop="address">
            </el-table-column>
            <el-table-column
              label="当前状态"
              fixed="right"
              width="100"
              align="center"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="warning">待接单</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6" class="tcf-tag-2">待拆单</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===7" class="tcf-tag-6">订单确认</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===8" class="tcf-tag-3">待报价</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9" class="tcf-tag-9">预付款</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===10" class="tcf-tag-7">工厂分派</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===88" class="tcf-tag-1">待审单</el-tag>
                <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDesignerOrderList, getDesignerList } from '@/api/erp'

export default {
  name: 'cdsjs',
  data() {
    return {
      tableData: [],
      loading: false,
      dialogLoading: false,
      visible: false,
      dialogData: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getDesignerList().then(response => {
        const tempData = []
        response.data.forEach(a => {
          if (a.dName !== '郑旭桃' && a.dName !== '陈浩晨' && a.dName !== '何杰' && a.dName !== '左俊杰' && a.dName !== '陶晓敏') {
            tempData.push(a)
          }
        })
        this.tableData = tempData
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getDetail(userid) {
      this.dialogData = []
      this.visible = true
      this.dialogLoading = true
      getDesignerOrderList({ userid: userid }).then(response => {
        this.dialogData = response.data
        this.dialogLoading = false
      }).catch(() => {
        this.dialogLoading = true
      })
    },
    goDetail(orderid) {
      this.visible = false
      this.$router.push({
        path: '/work/order/' + orderid
      })
    },
    filterType(value, row) {
      return row.type === value
    }
  }
}
</script>

<style scoped>

</style>
